import {Box,CheckboxGroup,Checkbox,Stack,useToast,Text, Input, Spacer, Accordion, AccordionItem,AccordionPanel,AccordionButton,
    AccordionIcon, ButtonGroup, Button} from '@chakra-ui/react'
import { useEffect,useState } from 'react'
import { getKnjigeLokacije } from '../../util/apiKnjiga';
import { MdFilterAlt,MdCancel} from 'react-icons/md';



export default function IzlucenjaFilter({onSetFilter, onClose}) {
   const [knjige,setKnjige]=useState({});
   
   const [lokacije,setLokacije]=useState([]);
   const [filter,setFilter]=useState({posjednikSelect:false,klsonicaSelect:false,posjednici:[],klaonice:[],knjige:[],noveknjige:[],odlazaktipovi:[],datumod:(new Date().getFullYear()-1).toString()+'-01-01',
       datumdo:new Date().toISOString().split("T")[0],drzave:[]})
   const toast=useToast();
   const fetchKnjige=async ()=>{
       try {
           const res=await getKnjigeLokacije();
           if (res.status===200) {
               setKnjige(res.res)
               let _oldlok="";
               const _lok=[];
               res.res.map((knjiga,i)=>{
                   if (knjiga.lokacija!==_oldlok) {
                       _lok.push(knjiga.lokacija)
                       _oldlok=knjiga.lokacija
                   }
                       
                   
               })
               setLokacije(_lok);
           } else {
               throw new Error(res.message);
           }
       } catch (error) {
           toast({
               title:"Greška kod dohvata podataka.",
               status:"error",
               description:error.message,
               isClosable:true,
               duration:2000,
               position:"top-right",
           });
       }
   }
   
   useEffect(() => {
     fetchKnjige();
   }, [])
   
   const onCheckKnjiga=(_noveknjige,event)=>{
       const _knjid=event.target.value;
       const _add=event.target.checked;
       let _knjige;
       if (_noveknjige) {
        _knjige=filter.noveknjige;
       } else {
        _knjige=filter.knjige;
       }
       
       const idx=_knjige.findIndex(knjigaid=>knjigaid===_knjid);
       
       if (_add && idx===-1) {//dodaje se knjiga te ista ne postoji u state-u
           _knjige.push(_knjid);
      } else if (!_add && idx!==-1) {//odchekirana je knjiga te ju treba maknuti iz state-a
           _knjige.splice(idx,1);
       }
       if (_noveknjige) {
        setFilter({...filter,noveknjigeknjige:_knjige});
       } else {
        setFilter({...filter,knjige:_knjige});
       }
       
   }


  
   const showKnjige=(_noveknjige=false)=>{
       

       if (JSON.stringify(knjige)!=="{}") {
           return (
               <Box w={'100%'}>
                   <CheckboxGroup colorScheme='grunt2'>
                       {lokacije.map((lokacija,i)=>{
                           return(
                               <Box display={'flex'} flexDir={'row'} w='100%' m='0.5rem'>
                               <Box w='20%'>
                               <Text fontWeight={'semibold'}>{lokacija}</Text>
                               </Box>
                               <Box w='80%'>
                               <Stack spacing={[15]} direction={['column', 'row']} mb={'0.5rem'}>
                                   return (
                                       {knjige.map((knjiga,i)=>{
                                           if (knjiga.lokacija===lokacija) {
                                               return (<Checkbox fontSize={'xs'} value={knjiga.knjiga_id.toString()} onChange={(e)=>onCheckKnjiga(_noveknjige,e)}>{knjiga.knjiga}</Checkbox>)
                                           }
                                       })}
                                   )
                               </Stack>
                               </Box>
                               </Box>
                           )

                       })}
                   </CheckboxGroup>
               </Box>
           )            
       }
   }

   
   

   const changeDatum=(event)=>{
       if (event.target.id==="idDatOd") {
           setFilter({...filter,datumod:event.target.value})
       } else if (event.target.id==="idDatDo") {
           setFilter({...filter,datumdo:event.target.value})
       }
   }

   const showDatumi=()=>{
       return (
           <Box w={'100%'}>
               <Box display={'flex'} flexDir={'row'} w='100%' m='0.5rem'>
                   <Box w='49%'>
                       <Text>Od datuma:</Text>
                       <Input focusBorderColor='grunt2.400' id="idDatOd" size="md"  type="date" variant={'filled'} value={filter.datumod} onChange={changeDatum}/>
                   </Box>
                   <Spacer/>
                   <Box w='49%'>
                       <Text>Do datuma:</Text>
                       <Input focusBorderColor='grunt2.400' id="idDatDo" size="md"  type="date" variant={'filled'} value={filter.datumdo}  onChange={changeDatum}/>
                   </Box>
               </Box>
                           

            </Box>
       )
   }














const onApplyFilter=()=>{
   //onSetFilter(filter);
   let _pos=[];
   let _kl=[];
   
   filter.posjednici.map((posjednik,i)=>{
       _pos.push(posjednik.id);
   })
//
   filter.klaonice.map((kl,i)=>{
    _kl.push(kl.id);
   })

   onSetFilter({datumod:filter.datumod,datumdo:filter.datumdo,knjige:filter.knjige,odlazaktipovi:filter.odlazaktipovi,
   noviposjednici:_pos,drzave:filter.drzave,noveknjige:filter.noveknjige,klaonice:_kl});
}

 return (
   <Box>
   <Box w={'100%'} h='85vh' overflowY={'auto'}>

       <Accordion allowToggle>
           <AccordionItem>
               <h2>
                   <AccordionButton>
                       <Box as="span" flex='1' textAlign='left' fontWeight={'semibold'}>
                           Knjige
                       </Box>
                       <AccordionIcon />
               </AccordionButton>
               </h2>
               <AccordionPanel pb={4}>
                   {showKnjige()}
               </AccordionPanel>
           </AccordionItem>
           
           <AccordionItem>
               {/* <h2> */}
                   <AccordionButton>
                       <Box as="span" flex='1' textAlign='left' fontWeight={'semibold'}>
                           Datumi izlučenja
                       </Box>
                       <AccordionIcon />
               </AccordionButton>
               {/* </h2> */}
               <AccordionPanel pb={4}>
                   {showDatumi()}
               </AccordionPanel>
           </AccordionItem>
          
        
        
       </Accordion>
       
   </Box>
   <ButtonGroup gap={'2rem'} mt={'0.5rem'}>
           <Button  rightIcon={<MdFilterAlt/>} colorScheme={'grunt2'} size={'sm'} onClick={onApplyFilter}>Filtriraj</Button>
           <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={'sm'} onClick={onClose}>Odustani</Button>
       </ButtonGroup>
   </Box>
 )
}
